export default {
  root: {
    fontWeight: 500
  }
};
